import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {property} from 'lit/decorators/property.js';
import {FeatureSelectItem} from './featureSelectItem';
import {pimText} from '../../util/values';
import {widgetButton} from '../../css/styleSets';

@customElement('feature-combo-select-item')
export class FeatureComboSelectItem extends FeatureSelectItem {

	@property({type: Boolean})
	active = false;

	static styles = [
		widgetButton,
		css`
			:host {
				list-style: none;
			}

			.item {
				position: relative;
				padding-right: 1px;
			}

			button {
				display: none;
				overflow: hidden;
				height: 0;
				opacity: 0;
				border: 0 none;
				padding: 0 0.5em;
			}

			.active button {
				opacity: 1;
				height: var(--height-widget);
				padding: 0.5em 0.5em;
				display: block;
			}

			.selected button {
				height: var(--height-widget);
				opacity: 1;
				background-color: var(--color-widget-background-selected);
				padding: 0.5em 0.5em;
				display: block;
			}



			.fixed button {
				border: var(--border-widget-fixed);
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-grey5);
			}

			.disabled button:hover {
				color: var(--color-white);
			}
		`];

		async onClick() {
			console.log('Button clicked');
			const selectedValue = this.featureValue.featureValueId;
			this.dispatchEvent(new CustomEvent('select-value', { bubbles: true, composed: true, detail: { selectedValue: selectedValue }}));
			if (this.active) {
				await this.toggleDecision();
				// deactivate parent
				this.dispatchEvent(new CustomEvent('deactivate-combo', {bubbles: true, composed: true}));
			} else {
				// activate parent
				this.dispatchEvent(new CustomEvent('activate-combo', {bubbles: true, composed: true}));
			}
		}

		//async onClick() {
		//	console.log('Button clicked');
		//	if (this.active) {
		//		await this.toggleDecision();
		//		const selectedValue = this.featureValue.featureValueId;
		//		this.dispatchEvent(new CustomEvent('select-value', { bubbles: true, composed: true, detail: { selectedValue }}));
		//		this.dispatchEvent(new CustomEvent('deactivate-combo', { bubbles: true,composed: true, detail: { selectedValue }}));
		//	} else {
		//		const selectedValue = this.featureValue.featureValueId;
		//		this.dispatchEvent(new CustomEvent('activate-combo', {bubbles: true, composed: true, detail: { selectedValue }}));
		//	}
		//}

	render() {
		return html`
		<div class="item ${classMap({active: this.active, selected: this.isIncluded(), disabled: !this.canBeIncluded(), fixed: !this.canBeExcluded()})}">
				<button @click="${this.onClick}">
					 <trans-label key="${this.feature.variableId}" value="${this.featureValue.featureValueId}" context="FV"></trans-label>
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.getInfoText()}
						</div>
					</div>
				`)}
			</div>
		`;
	}
}
